import React, { Suspense } from 'react';
import { Button, ButtonProps } from '@cp/ds/src/components/button';
export type { ButtonProps } from '@cp/ds/src/components/button';
import { Skeleton } from '@cp/ds/src/components/skeleton';

export const ButtonTemplate = (props: ButtonProps) => {
  return (
    <Button
      color="gray ultra light"
      labelSx={{ justifyContent: 'flex-start', gap: 1.5 }}
      sx={{ backgroundColor: '#fff' }}
      variant="secondary"
      {...props}
    >
      <Suspense fallback={<Skeleton width="100%" />}>{props.children}</Suspense>
    </Button>
  );
};
